import type { Intervention } from "types/api/intervention";
import { makeAddressString } from "./service_date";
import { getInterventionDateTime } from "./service_intervention";

type GoogleCalendarEventOptions = {
    title: string,
    description: string,
    location: string,
    start?: Date,
    end?: Date
}

function parse_date(date: Date) {

    let str = date.toISOString();
    const [d, t] = str.split('T');
    const [h, m] = t.split(':');
    const date_str = d.replace(/\-/g, "");
    const time = `${h}${m}00`;
    return `${date_str}T${time}Z`;
}

function parse_time(start: Date, end: Date): string {
    return `${parse_date(start)}/${parse_date(end)}`
}

export function generate_calendar_event_from_intervention(intervention: Intervention): GoogleCalendarEventOptions {
    return {
        title: `GAE - ${intervention.title} - ${intervention.customer}`,
        description: intervention.comment ?? "",
        location: makeAddressString(intervention.address, intervention.postcode, intervention.city),
        start: getInterventionDateTime(intervention.date, intervention.startTime),
        end: getInterventionDateTime(intervention.date, intervention.endTime),
    }

}

//https://www.google.com/calendar/render?action=TEMPLATE&text=test&details=test&location=test&dates=20240122T135500Z%2F20240123T135500Z
export function generate_calendar_event(options: GoogleCalendarEventOptions): string {
    const url = new URL("https://www.google.com/calendar/render");
    url.searchParams.append("action", "TEMPLATE")
    url.searchParams.append("text", options.title)
    url.searchParams.append("details", options.description)
    url.searchParams.append("location", options.location)
    if (options.start && options.end)
        url.searchParams.append("dates", parse_time(options.start, options.end))

    return url.toString();
}
